class CommentsModel {
  constructor(id,content,postid,userid,date,userImg,email,dCount,pCount,parentId,userVote,media) {
    this.id =id;
    this.content = content;
    this.postid = postid;
    this.userid = userid;
    this.date = date;
    this.userImg = userImg;
    this.email = email;
    this.dCount = dCount;
    this.pCount = pCount;
    this.parentId = parentId && String(parentId) !== 'null' ? String(parentId) : null;
    this.userVote = userVote ? String(userVote).trim() : null;
    this.media = media || null;
  }
}
export default CommentsModel;
